"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var ApproveErc20_1 = require("./ApproveErc20");

var PolymathError_1 = require("../PolymathError");

var utils_1 = require("../utils");

var entities_1 = require("../entities");
/**
 * Procedure to create a Dividend Distribution on a Security Token.
 * The funds to be distributed as dividends will come from the current user's wallet
 */


var CreateDividendDistribution =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(CreateDividendDistribution, _Procedure_1$Procedur);

  function CreateDividendDistribution() {
    var _this;

    _classCallCheck(this, CreateDividendDistribution);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CreateDividendDistribution).apply(this, arguments));
    _this.type = types_1.ProcedureType.CreateDividendDistribution;
    return _this;
  }
  /**
   * - Approve spend of the amount that will be distributed
   * - Create a Dividend Distribution for said amount
   * - Set tax withholding percentages (if supplied)
   * - Return the newly created Dividend Distribution
   *
   * Note that this procedure will fail if the ERC20 Dividends Feature has not been enabled
   */


  _createClass(CreateDividendDistribution, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var args, context, symbol, maturityDate, expiryDate, erc20Address, amount, checkpointIndex, name, _args$excludedAddress, excludedAddresses, _args$taxWithholdings, taxWithholdings, contractWrappers, factories, erc20Module, _ref, _ref2, distribution, investors, percentages;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                args = this.args, context = this.context;
                symbol = args.symbol, maturityDate = args.maturityDate, expiryDate = args.expiryDate, erc20Address = args.erc20Address, amount = args.amount, checkpointIndex = args.checkpointIndex, name = args.name, _args$excludedAddress = args.excludedAddresses, excludedAddresses = _args$excludedAddress === void 0 ? [] : _args$excludedAddress, _args$taxWithholdings = args.taxWithholdings, taxWithholdings = _args$taxWithholdings === void 0 ? [] : _args$taxWithholdings;
                contractWrappers = context.contractWrappers, factories = context.factories;
                _context2.prev = 3;
                _context2.next = 6;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 6:
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](3);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 11:
                _context2.next = 13;
                return contractWrappers.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.ERC20DividendCheckpoint,
                  symbol: symbol
                }, {
                  unarchived: true
                });

              case 13:
                erc20Module = _context2.sent[0];

                if (erc20Module) {
                  _context2.next = 16;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "The ERC20 Dividends Manager hasn't been enabled"
                });

              case 16:
                _context2.t1 = this.addProcedure(ApproveErc20_1.ApproveErc20);
                _context2.t2 = amount;
                _context2.next = 20;
                return erc20Module.address();

              case 20:
                _context2.t3 = _context2.sent;
                _context2.t4 = erc20Address;
                _context2.t5 = {
                  amount: _context2.t2,
                  spender: _context2.t3,
                  tokenAddress: _context2.t4
                };
                _context2.next = 25;
                return (0, _context2.t1)(_context2.t5);

              case 25:
                _context2.next = 27;
                return this.addTransaction(erc20Module.createDividendWithCheckpointAndExclusions, {
                  tag: types_1.PolyTransactionTag.CreateErc20DividendDistribution,
                  resolvers: [function (receipt) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee() {
                      var logs, _utils_1$findEvents, _utils_1$findEvents2, event, eventArgs, _dividendIndex;

                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              logs = receipt.logs;
                              _utils_1$findEvents = utils_1.findEvents({
                                eventName: contract_wrappers_1.ERC20DividendCheckpointEvents.ERC20DividendDeposited,
                                logs: logs
                              }), _utils_1$findEvents2 = _slicedToArray(_utils_1$findEvents, 1), event = _utils_1$findEvents2[0];

                              if (!event) {
                                _context.next = 6;
                                break;
                              }

                              eventArgs = event.args;
                              _dividendIndex = eventArgs._dividendIndex;
                              return _context.abrupt("return", factories.dividendDistributionFactory.fetch(entities_1.DividendDistribution.generateId({
                                securityTokenId: entities_1.SecurityToken.generateId({
                                  symbol: symbol
                                }),
                                index: _dividendIndex.toNumber()
                              })));

                            case 6:
                              throw new PolymathError_1.PolymathError({
                                code: types_1.ErrorCode.UnexpectedEventLogs,
                                message: "The ERC20 Dividend Distribution was successfully created but the corresponding event wasn't fired. Please report this issue to the Polymath team."
                              });

                            case 7:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));
                  }]
                })({
                  maturity: maturityDate,
                  expiry: expiryDate,
                  token: erc20Address,
                  amount: amount,
                  checkpointId: checkpointIndex,
                  name: name,
                  excluded: excludedAddresses
                });

              case 27:
                _ref = _context2.sent;
                _ref2 = _slicedToArray(_ref, 1);
                distribution = _ref2[0];

                if (!(taxWithholdings.length > 0)) {
                  _context2.next = 36;
                  break;
                }

                investors = [];
                percentages = [];
                taxWithholdings.forEach(function (_ref3) {
                  var address = _ref3.address,
                      percentage = _ref3.percentage;
                  investors.push(address);
                  percentages.push(new contract_wrappers_1.BigNumber(percentage));
                });
                _context2.next = 36;
                return this.addTransaction(erc20Module.setWithholding, {
                  tag: types_1.PolyTransactionTag.SetErc20TaxWithholding
                })({
                  investors: investors,
                  withholding: percentages
                });

              case 36:
                return _context2.abrupt("return", distribution);

              case 37:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 8]]);
      }));
    }
  }]);

  return CreateDividendDistribution;
}(Procedure_1.Procedure);

exports.CreateDividendDistribution = CreateDividendDistribution;